module.exports = __webpack_public_path__ + "img/dubrovny.98e1d2c2.png";